import YouTubeIcon from '@mui/icons-material/YouTube'
import TippeeeIcon from '../components/Icons/TipeeLogo'
export const SourceIdMap = {
    "446427676": TippeeeIcon,
    "YouTube": YouTubeIcon,
    "SimpleTip": 'asdkkasdfk'

}